module.exports = __webpack_public_path__ + "static/media/auto-hippo-gator.17ea03e4.svg";